(async () => {
  if (customElements.get('ups-bar')) return;

  const { default: Swiper, A11y, Autoplay } = await import('swiper');

  Swiper.use([A11y, Autoplay]);

  class UspBar extends HTMLElement {
    constructor() {
      super();

      // If usp bar removed is true, destroy it and stop the script.
      const uspBarRemoved = sessionStorage.getItem('usp-bar-removed');
      if (uspBarRemoved) return this.remove();

      // Get elements
      this.swiper = this.querySelector('[data-swiper]');
      this.blocksSize = parseInt(this.swiper.dataset.blocksSize);
      this.removeButton = this.querySelector('[data-remove-button]');

      // Stop when the swiper is not found
      if (!this.swiper) return;

      // Check if we have extra options on the HTML
      if (this.swiper.dataset.options) {
        this.options = JSON.parse(this.swiper.dataset.options);
      }

      // Call swiper with selected swiper element and options
      this.swiperInstance = new Swiper(this.swiper, {
        threshold: 10,
        slidesPerView: 1,
        spaceBetween: 16,
        loop: true,
        autoplay: {
          delay: 5000,
        },
        breakpoints: {
          480: {
            slidesPerView: this.blocksSize >= 2 ? 2 : this.blocksSize,
          },
          768: {
            slidesPerView: this.blocksSize >= 3 ? 3 : this.blocksSize,
          },
          1280: {
            slidesPerView: this.blocksSize >= 4 ? 4 : this.blocksSize,
          },
        },
        on: {
          init: (swiper) => {
            // Stop autoplay if amount of blocks equals slidePerView
            if (this.blocksSize === swiper.params.slidesPerView) swiper.autoplay.stop();
          },
          breakpoint: (swiper, { slidesPerView }) => {
            // Start or Stop autoplay based on amount of blocks compared to slidesPerView
            const { start, stop } = swiper.autoplay;
            this.blocksSize === slidesPerView ? stop() : start();
          },
        },
        ...this.options,
      });

      // Handle design mode events
      this.handleDesignModeEvents();

      // Handle remove button click
      this.removeButton.addEventListener('click', () => {
        this.remove();
      });
    }

    /**
     * Handles the theme editor block change/edit event
     * @param {Object} event
     */
    handleBlockSelect({ dataset }) {
      // Check if the slide index is set
      if (!('swiperSlideIndex' in dataset)) return;

      // Set the slide index based on loop settings or not
      let swipeToSlideIndex = parseInt(dataset.swiperSlideIndex) - 1;
      if (this.swiperInstance.params.loop)
        swipeToSlideIndex = parseInt(dataset.swiperSlideIndex) + 1;

      // Slide to slide based on the data attribute from the target
      this.swiperInstance.slideTo(swipeToSlideIndex, 1000);
    }

    /**
     * Handle design mode events
     * @returns void
     */
    handleDesignModeEvents() {
      if (!Shopify.designMode) return;

      // Update the swiper when the section event is triggered
      ['shopify:section:load', 'shopify:block:select', 'shopify:block:deselect'].forEach(
        (inputEvent) => {
          window.addEventListener(inputEvent, (event) => {
            this.swiperInstance.update();

            if (inputEvent === 'shopify:block:select' || inputEvent === 'shopify:block:deselect')
              this.handleBlockSelect(event.target);
          });
        }
      );
    }
  }

  window.UspBar = UspBar;

  customElements.define('usp-bar', UspBar);
})();
